import React from 'react';

import { NumberInput, Stack, Text } from '@mantine/core';

import { blockNonInteger, RoundsResult } from './types';

interface RoundsInputProps {
  value: RoundsResult;
  onChange: (value: RoundsResult) => void;
  enlarged?: boolean;
}

const RoundsInput = ({ value, onChange, enlarged = false }: RoundsInputProps): JSX.Element => (
  <Stack spacing={4}>
    <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
      Total Rounds
    </Text>
    <NumberInput
      value={value.rounds}
      onChange={rounds => onChange({ ...value, rounds })}
      min={0}
      precision={0}
      inputMode='numeric'
      onKeyDown={blockNonInteger}
      size={enlarged ? 'xl' : 'md'}
    />
  </Stack>
);

export default RoundsInput;
